import { enUS } from 'date-fns/locale/en-US';
import { ar } from 'date-fns/locale/ar';
import { id } from 'date-fns/locale/id';
import { pt } from 'date-fns/locale/pt';
import { zhCN } from 'date-fns/locale/zh-CN';
import { da } from 'date-fns/locale/da';
import { es } from 'date-fns/locale/es';
import { fr } from 'date-fns/locale/fr';
import { de } from 'date-fns/locale/de';
import { ja } from 'date-fns/locale/ja';
import { ko } from 'date-fns/locale/ko';
import { nl } from 'date-fns/locale/nl';
import { nb } from 'date-fns/locale/nb';
import { pl } from 'date-fns/locale/pl';
import { ru } from 'date-fns/locale/ru';
import { sv } from 'date-fns/locale/sv';
import { tr } from 'date-fns/locale/tr';
import { cs } from 'date-fns/locale/cs';
import { he } from 'date-fns/locale/he';
import { th } from 'date-fns/locale/th';
import { zhTW } from 'date-fns/locale/zh-TW';
import { it } from 'date-fns/locale/it';
import { hi } from 'date-fns/locale/hi';
import { ta } from 'date-fns/locale/ta';
import { bn } from 'date-fns/locale/bn';
import { vi } from 'date-fns/locale/vi';
import { el } from 'date-fns/locale/el';
import { te } from 'date-fns/locale/te';
import { uk } from 'date-fns/locale/uk';
import { ro } from 'date-fns/locale/ro';

export const DATE_FNS_LOCALES = {
  en_US: enUS,
  ar_EG: ar,
  in_ID: id,
  pt_BR: pt,
  zh_CN: zhCN,
  da_DK: da,
  es_MX: es,
  fr_FR: fr,
  de_DE: de,
  ja_JP: ja,
  ko_KR: ko,
  nl_NL: nl,
  nb_NO: nb,
  pl_PL: pl,
  ru_RU: ru,
  sv_SE: sv,
  tr_TR: tr,
  cs_CZ: cs,
  he_IL: he,
  th_TH: th,
  zh_TW: zhTW,
  it_IT: it,
  hi_IN: hi,
  ta_IN: ta,
  bn_BD: bn,
  vi_VN: vi,
  el_GR: el,
  te_IN: te,
  uk_UA: uk,
  ro_RO: ro
};
